module.exports = __webpack_public_path__ + "static/media/uptu_logo.5d7dfab9.png";